// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + (chunkId === 105 ? "views-Dashboard" : chunkId) + "." + {"105":"d4396347","187":"8c5b220b"}[chunkId] + ".css";
};